/* eslint-disable @typescript-eslint/naming-convention */
import { NoteService } from './../services/note_service';
import { StreamService } from '../services/stream_service';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';

export function ValidateCustomUrlDuplication(
    service: NoteService | StreamService, parent: {id: number | string; type: string}
    ): AsyncValidatorFn {
    let interval: any;
    const timeout = 2000;
    const objectType = parent.type === 'note' ? 'post' : 'channel';

    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => new Promise(resolve => {
            if (interval) {
                clearTimeout(interval);
            }

            interval = setTimeout(() => {
                service['validateCustomUrlDuplication'](control.value)
                    .then(result => {
                        resolve(
                            result && (result.code === 'DOES_NOT_EXIST' || result[objectType].id === parent.id) ?
                                null : {urlDuplicated: true}
                        );
                    })
                    .catch(err => {
                        resolve(null);
                    });
            }, timeout > 0 ? timeout : 3000);
        });
}
